import { getData } from "./apiService";

  export const checkPhoneNumberStopped = async (phone_number: string): Promise<PhoneNumberCheckResponse> => {
    try {
      const response = await getData(`/phone-number-check`, {phone_number: phone_number});
      return response as PhoneNumberCheckResponse;
    } catch (error) {
      console.error('Failed to fetch organizations:', error);
    }
    throw Error('Error checking phone number with server.');
  };


  export type PhoneNumberCheckResponse = {
    valid: boolean;
    stopped: boolean;
    sender_phone_number: string;
    error: string;
  }